export default __webpack_public_path__ + "static/media/Quartermaster's War Band.5c6b06d7.jpg";